import { render, staticRenderFns } from "./CloudArrowUp.vue?vue&type=template&id=a5fd72f0&scoped=true"
import script from "./CloudArrowUp.vue?vue&type=script&lang=js"
export * from "./CloudArrowUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5fd72f0",
  null
  
)

export default component.exports